import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import StoreSummaryAccessDenied from '../components/StoreSummaryAccessDenied';
import StoreSummaryFiltersBar from '../components/StoreSummaryFiltersBar';
import StoreSummaryStoresTable from '../components/StoreSummaryStoresTable';
import { getStoreSummaryColumns } from '../components/getStoreSummaryColumns';
import { useStoreSummaryListing } from '../hooks/useStoreSummaryListing';

const StoreSummaryPage: React.FC = () => {
  const { model, actions } = useStoreSummaryListing();
  const columns = useMemo(() => getStoreSummaryColumns(), []);

  if (!model.isSuperAdmin) {
    return <StoreSummaryAccessDenied onBack={actions.onBackToScratchers} />;
  }

  return (
    <Box>
      {model.error ? (
        <Typography color="error" mb={2}>
          {model.error}
        </Typography>
      ) : null}

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 2, pt: 1 }}>
        <Box sx={{ width: '50%' }}>
          <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '24px' }}>
            All Stores
          </Typography>
        </Box>

        <Box sx={{ width: '50%' }}>
          <StoreSummaryFiltersBar
            statusFilter={model.statusFilter}
            onStatusChange={actions.onStatusChange}
            search={model.search}
            onSearchChange={actions.onSearchChange}
          />
        </Box>
      </Box>

      <Box
        sx={{
          borderRadius: 2,
          border: '1px solid #e0e0e0',
          backgroundColor: '#FFFFFF',
          boxShadow: '0 2px 8px rgb(34 43 69 / 8%)',
        }}
      >
        <StoreSummaryStoresTable
          columns={columns}
          rows={model.rows}
          orderBy={model.orderBy}
          order={model.order}
          onRequestSort={actions.onRequestSort}
          total={model.total}
          page={model.page}
          pageSize={model.pageSize}
          onPageChange={actions.onPageChange}
          onRowsPerPageChange={actions.onRowsPerPageChange}
          onRowClick={actions.onRowClick}
          loading={model.loading}
        />
      </Box>
    </Box>
  );
};

export default StoreSummaryPage;
